import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, ScrollView,
	Dimensions, Image, FlatList, AsyncStorage, Platform } from "react-native";

import { format, parse } from 'date-fns'

import * as Font from 'expo-font';
import { color } from "../config/color"
import store from "../config/config.json"

import { Ionicons } from "@expo/vector-icons";
import Main from "../widgets/Main";
import MainComponent from "../utilities/MainComponent";
import i18next from "i18next";

export default class OrderScreen extends MainComponent {	
	
	state = {
		store: {},
		isLoading: false,
		deliveryData: {area: {name: ""}},
		userData : [],
		orderData: [],
		showFullMode 	: true,
		isLoading: false,
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);

		this.state.showError = false
	
		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth

		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		this.getDetails()
	}

	getDetails = async () => {		
		
		await Font.loadAsync(color.appFonts);
		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
			{
				value = JSON.parse(value)			
	            this.setState({store: value})
			}
			
        } catch (error) {
            console.log(error)
		}
		
		try {
			
			this.setState({deliveryData: deliveryData, userData: userData, orderData: orderData, totalPrice: totalPrice * totalCount, promoData: promoData});		
			
		} catch (error) {
			this.setState({isLoading: false})
			console.log(error);			
		}
	}

	onSubmit(){

	}

	
	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */
	
	// List View 
	renderDetails(){

		let height = 2.5
		var paymentType = ""
		if(this.state.mainData.payType == payment.PAY_BY_KNET)
			paymentType = i18n.t("knet")
		else if(this.state.mainData.payType == payment.PAY_BY_CASH)
			paymentType = i18n.t("payCash")
		else if(this.state.mainData.payType == payment.PAY_BY_CARD)
			paymentType = i18n.t("card")

			var timings = ""
			if(this.state.deliveryData != undefined && this.state.deliveryData.timings != undefined && this.state.deliveryData.timings != "")
			{
				try{
					timings = format(parse(this.state.deliveryData.timings.date, 'dd-MM-yyyy', new Date()), 'dd MMM') + " " +  this.state.deliveryData.timings.data.openingTime + " - " + this.state.deliveryData.timings.data.closingTime
				}catch{
					timings =  i18n.t(this.state.deliveryData.timings.date, {defaultValue: this.state.deliveryData.timings.date})
				}
			}

		var mainArea = this.state.userData.block + ", " + this.state.userData.street + ", " + this.state.userData.avenue + ", "
		mainArea = this.state.userData.house + ", " + this.state.userData.building + ", " + this.state.userData.floor

		return (
			<View style={styles.container}>

				<View style={{height: height, flexDirection: "row", marginTop: 50}}>

					<View style={{height: height, width: 5}}/>
								
					<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
					<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
					<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
					<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>

				</View>
				{ this.state.showError  && (
					<View style={{height: 25, backgroundColor: 'red', justifyContent: "center", alignContent: "center", alignItems: "center"}}>
							<Text style={{ fontFamily: 'main-regular',color:color.details, fontSize:14, color: "white", textAlign: "center"}}>{this.state.errorMessage}</Text>		
					</View>
				)}
				
				<ScrollView style={{flex: 1, backgroundColor:color.bigSeparator, width: "100%"}}>
					
					<View style={{height: 8,backgroundColor:color.bigSeparator}}/>

					<View style={{justifyContent: "center", width: "100%", backgroundColor: 'white'}}>

							<TouchableOpacity style={{marginLeft: 15, marginRight: 15, height: 40}}
												onPress={() => { 
													//this.openOrders()
												}}
							>
								<View style={{flexDirection: "row", flex:1, justifyContent: "center", alignItems:"center", alignItems: "center"}}>
									<Text style={{fontFamily: 'main-bold', color: 'black', fontSize:14, textAlign: "center"}}>Order Items</Text>	
									<Ionicons style={{marginLeft: "auto",}} size={15} color='black' />	
								</View>

							</TouchableOpacity>

							<View style={{flex: 1}}>
								<FlatList
									extraData={this.state}
									data={this.state.orderData}
									renderItem={this.renderListItem}
									keyExtractor={item => item.name}
								/>
							</View>
					</View>

					<View style={{height: 4,backgroundColor:'white'}}/>
					<View style={{height: 8,backgroundColor:color.bigSeparator}}/>

					<TouchableOpacity style={{paddingLeft: 15, paddingRight: 15, height: 40, backgroundColor: 'white'}}
												onPress={() => { 
													//this.openOrders() 
												}}
							>
								<View style={{flexDirection: "row", flex:1, justifyContent: "center", alignItems:"center", alignItems: "center"}}>
									<Text style={{fontFamily: 'main-bold', color: 'black', fontSize:14, textAlign: "center"}}>Delivery Info</Text>	
									<Ionicons style={{marginLeft: "auto",}} size={20} color='black' />	
								</View>

					</TouchableOpacity>

					<View style={{flexDirection: "row", height: 50, paddingLeft: 15, paddingRight: 15, alignItems:"center", alignItems: "center", backgroundColor: 'white'}} >
						<Ionicons style={{marginRight: 5}} name="ios-calendar" size={20} color='black' />	
						<Text style={{marginLeft: 10, fontFamily: 'main-regular',color: 'black', fontSize:14, textAlign: "center"}}>{timings}</Text>	
					</View>

					<View style={{height: 1,backgroundColor:color.bigSeparator}}/>
					
					<View style={{flexDirection: "row", height: 65, paddingLeft: 15, paddingRight: 15, alignItems:"center", alignItems: "center", backgroundColor: 'white'}} >						
						<Ionicons style={{marginRight: 5}} name="md-business" size={20} color='black' />	
						<View style={{marginLeft: 10}} >
								<Text style={{fontFamily: 'main-regular',color: 'black', fontSize:14, }}>{this.state.deliveryData.area.name}</Text>	
								<Text style={{fontFamily: 'main-regular',color: 'black', fontSize:14, }}>{mainArea}</Text>	
						</View>
						<Ionicons style={{marginLeft: "auto"}} name="ios-arrow-forward" size={15} color='black' />	
					</View>

					<View style={{height: 1,backgroundColor:color.bigSeparator}}/>

					<View style={{backgroundColor: 'white', flexDirection: "row", height: 65, paddingLeft: 15, paddingRight: 15, alignItems:"center", alignItems: "center"}} >						
						<Ionicons style={{marginRight: 5}} name="md-locate" size={20} color='black' />	
						<View style={{marginLeft: 10}} >
								<Text style={{fontFamily: 'main-regular',color: 'black', fontSize:14, }}>{this.state.userData.name}</Text>	
								<Text style={{fontFamily: 'main-regular',color: 'black', fontSize:14, }}>{this.state.userData.phone}</Text>	
						</View>
						<Ionicons style={{marginLeft: "auto"}} name="ios-arrow-forward" size={15} color='black' />	
					</View>					

					<View style={{height: 8,backgroundColor:color.bigSeparator}}/>	

					<Text style={{paddingTop: 10, paddingLeft: 15, fontFamily: 'main-bold', color: 'black', fontSize:14, backgroundColor: 'white'}}>Payment Method</Text>	
					<TouchableOpacity style={{paddingLeft: 15, paddingRight: 15, height: 40, paddingTop: 10, backgroundColor: 'white'}}
												onPress={() => { 
													//this.openOrders() 
												}}
							>
								<View style={{flexDirection: "row", flex:1, justifyContent: "center", alignItems:"center", alignItems: "center"}}>
									<Text style={{fontFamily: 'main-regular', color: 'black', fontSize:14, textAlign: "center"}}>{paymentType}</Text>	
									<Ionicons style={{marginLeft: "auto"}} name="ios-arrow-forward" size={15} color='black' />	
								</View>

					</TouchableOpacity>

					<View style={{height: 8,backgroundColor:'white'}}/>		
					<View style={{height: 10,backgroundColor:color.bigSeparator}}/>		

					<View style={{height: 15,backgroundColor:'white'}}/>		
						<View style={{flex: 1, flexDirection: "row", paddingLeft: 15, paddingRight: 15, backgroundColor: 'white'}}>
						<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12}}>Delivery</Text>
						<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12, marginLeft: "auto"}}>-</Text>
						<View style={{height: 10,backgroundColor:'white'}}/>		
					</View>

					{ this.state.promoData != undefined && (
					<View style={{flex: 1, flexDirection: "row", paddingRight: 15, paddingLeft: 15, backgroundColor: 'white'}}>
						<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 15, fontWeight:"bold"}}>Promo Discount</Text>
						<Text style={{ fontFamily: 'main-regular', color: this.state.store.primaryColor, fontSize: 15, fontWeight:"bold", marginLeft: "auto"}}>KWD {this.state.promoData.discount}</Text>
					</View>
					)}

					<View style={{height: 10,backgroundColor:'white'}}/>		
					<View style={{flex: 1, flexDirection: "row", paddingRight: 15, paddingLeft: 15, backgroundColor: 'white'}}>
						<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 18, fontWeight:"bold"}}>Total</Text>
						<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 18, fontWeight:"bold", marginLeft: "auto"}}>KWD {this.state.totalPrice}</Text>
					</View>

					<View style={{height: 15,backgroundColor:'white'}}/>		

				</ScrollView>

				<View style={{height: 65, marginTop: "auto", backgroundColor:"white", justifyContent: "center"}}>
				
					<TouchableOpacity style={{marginLeft: 10, marginRight: 10, marginBottom: 10, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.onSubmit() }}
								>
					<View style={{justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
						<Text style={{ fontFamily: 'main-regular',color:'#FFF', fontWeight:"bold", fontSize:16}}>Finalize</Text>		
					</View>

					</TouchableOpacity>

				</View>

			</View>
		)
	}

	render() {
		var that = this
		return (
			<View style={styles.container}>

				{this.state.showFullMode && (										
					
					<View style={styles.webContainer}>						
						
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>

	                        {that.renderDetails()}

							<View style={styles.topBar}>															
								<View style={{width: '100%', position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
									<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>Order Deails</Text>																						
								</View>									
							</View>

						</View>

						<Main {...this.state} changeMenu={this.changeMenu} />

					</View>					
				)}
				
				{!this.state.showFullMode && !this.state.showMenu && (
					<View style={styles.container}>						
												
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height}}>
	                        {that.renderDetails()}
						</View>

						<View style={styles.topBar}>	
							<View style={{flex: 1, width: "100%", position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
								<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}></Text>																						
							</View>	
							<TouchableOpacity style={[styles.button], {marginLeft: 15}}
									onPress={() => { this.props.navigation.goBack(null) }} >
									<Ionicons name="ios-arrow-back" size={24} color={'black'} />
							</TouchableOpacity>													
						</View>
						
					</View>
				)}
				
			</View>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white'
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});